import { useT } from '../layout/i18n.ts';

export interface RejectedItem {
  /** Where it came from, e.g. `row 3, col XL` or `colour NAVY`. */
  readonly where: string;
  readonly value: string;
  readonly reasonKey: string;
}

/** BR-UI-002 / MB D22: every rejected pasted or imported value is listed with its reason; nothing is dropped silently. */
export function RejectedList({ items }: { readonly items: readonly RejectedItem[] }) {
  const t = useT();
  if (items.length === 0) return null;
  return (
    <div role="alert" className="skm-rejected">
      <p>{t('ui.rejected.title', { count: items.length })}</p>
      <ul>
        {items.map((i) => (
          <li key={`${i.where}:${i.value}`}>
            {i.where} — {i.value}: {t(i.reasonKey)}
          </li>
        ))}
      </ul>
    </div>
  );
}
